import { ANALYTICS_EVENT_NAMES } from "analytics/catalog/events";
import { buildCommonEventProps } from "analytics/core/commonProps";
import { trackEvent } from "analytics/core/tracker";

export type CreatorInviteAnalyticsContext = {
  pathname: string;
  search: string;
  businessId?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  planType?: string | null;
  currency?: string | null;
  compensationType?: string | null;
};

const buildCreatorInviteProps = (
  context: CreatorInviteAnalyticsContext,
): Record<string, unknown> => {
  return buildCommonEventProps({
    screenKey: "creator_invite",
    pathname: context.pathname,
    search: context.search,
    businessId: context.businessId ?? null,
    userId: context.userId ?? null,
    userEmail: context.userEmail ?? null,
    planType: context.planType ?? null,
    currency: context.currency ?? null,
    compensationType: context.compensationType ?? null,
  });
};

export const trackCreatorInvitePageViewed = (
  context: CreatorInviteAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.creatorInvitePageViewed,
    buildCreatorInviteProps(context),
  );
};

export const trackCreatorInviteSendInvitationClicked = (
  context: CreatorInviteAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.creatorInviteSendInvitationClicked,
    buildCreatorInviteProps(context),
  );
};

export const trackCreatorInviteConfirmSendClicked = (
  context: CreatorInviteAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.creatorInviteConfirmSendClicked,
    buildCreatorInviteProps(context),
  );
};
